import { render, staticRenderFns } from "./Sign.vue?vue&type=template&id=13698580&"
import script from "./Sign.vue?vue&type=script&lang=js&"
export * from "./Sign.vue?vue&type=script&lang=js&"
import style0 from "./Sign.vue?vue&type=style&index=0&id=13698580&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports